<template>
  <div class="d-flex justify-content-between mx-4 pt-4 ">
    <div >
      <h6 class="font-weight-bolder text-white">
        {{ currentRouteName }}
      </h6>
    </div>
    <div class="d-flex">
      <div>
        <span class="d-sm-inline px-3 font-weight-bold text-white" v-if="login" @click="LogOut()">로그아웃</span>
      </div>
      <div class="d-sm-inline px-3 font-weight-bold text-white" @click="toggleSidebar" v-if="mobile">
        <i class="fas fa-bars"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  name: "navbar",
  data() {
    return {
      showMenu: false,
      login : true,
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile
    };
  },
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize"]),

    toggleSidebar() {
      this.navbarMinimize();
    },
    LogOut(){
      this.$store.dispatch('SETLOGOUT').then(
        ()=>{
          window.location.href="/login";
        }
      )
    }
  },
  components: {
    
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  }
};
</script>
